module.exports = __webpack_public_path__ + "img/green-sticker.6475794.gif";